// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
// MARK: Components
import Input from "./input";
import CSSTypography from "components/common/typography";
// MARK: Functionality
import CSSStyles from "enums/cssStyles";
// MARK: Styled Components
interface ContainerProps {
  marginTop: number;
}
const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin-top: ${({ marginTop }) => marginTop}px;
`;

// MARK: React Component
// Props
interface Props {
  placeholder: string;
  value: string;
  onChange: (newValue: string) => void;
  errorMessage: string;
  errorIsActive: boolean;
  marginTop: number;
  textAlign?: string;
  disableBorder?: boolean;
}
// Styleguide & Datapoints
const getDatapoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary, error } = colors;
  return {
    inputStyle: CSSStyles.body,
    inputColor: primary,
    errorStyle: CSSStyles.navigation,
    errorColor: error,
  };
};
// Component
function InputWithErrorMessage({
  placeholder,
  value,
  onChange,
  errorMessage,
  errorIsActive,
  marginTop,
  textAlign,
  disableBorder,
}: Props) {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: State Variables
  // MARK: Use Effects
  // MARK: Variables
  const { gutter } = styleguide;
  const { inputStyle, inputColor, errorStyle, errorColor } =
    getDatapoints(styleguide);
  // MARK: Functionality

  // MARK: Render

  return (
    <Container marginTop={marginTop}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(ev) => {
          onChange(ev.target.value);
        }}
        className={inputStyle}
        color={inputColor}
        borderBottomColor={errorIsActive ? errorColor : inputColor}
        textAlign={textAlign}
        disableBorder={disableBorder}
      />
      <CSSTypography
        marginTop={errorIsActive ? gutter : 0}
        className={errorStyle}
        color={errorColor}
        textAlign={textAlign ? textAlign : "left"}
      >
        {errorIsActive ? errorMessage : ""}
      </CSSTypography>
    </Container>
  );
}

export default InputWithErrorMessage;
